import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b288efc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "backdrop" }, null, -1))
const _hoisted_2 = {
  class: "menu-content",
  role: "menuitem",
  "aria-label": "search-pannel"
}
const _hoisted_3 = {
  key: 1,
  class: "search-form",
  "aria-label": "search-pannel"
}

import {computed, ref, onMounted, onBeforeUnmount} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import {HeaderSearchSliceSlice} from '@/unlogged/prismicio';
    import {components} from '@/unlogged/slices';
    import Dropdown from './Dropdown.vue';
    import {useWindowNavGlobals} from '@/unlogged/composables/useWindowNavGlobals';

    type Props = {
        headerSearchSlice: HeaderSearchSliceSlice;
        alwaysShowSearch: boolean;
        pageWithSearch: boolean;
        searchPlaceholderText: string;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSearch',
  props: {
    headerSearchSlice: {},
    alwaysShowSearch: { type: Boolean },
    pageWithSearch: { type: Boolean },
    searchPlaceholderText: {}
  },
  setup(__props: any) {

const props = __props;

    

    const dropdownRef = ref();

    const scrollpx = ref(0);

    const {navTypeSearch, searchFormVisible} = useWindowNavGlobals();

    function handleScroll() {
        scrollpx.value = window.scrollY;
    }

    const searchVisible = computed(() => {
        if (navTypeSearch.value) {
            return true;
        }
        return props.pageWithSearch && (props.alwaysShowSearch || scrollpx.value > 600);
    });

    onMounted(() => {
        window.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
    });

return (_ctx: any,_cache: any) => {
  return (!_unref(searchFormVisible))
    ? (_openBlock(), _createBlock(Dropdown, {
        key: 0,
        id: "header-search",
        ref_key: "dropdownRef",
        ref: dropdownRef,
        class: _normalizeClass({
            'search-dropdown': true,
            'show-search': searchVisible.value,
        }),
        "data-heap": "navbar-unlogged_click-cta-button_search-button-input-new-cms",
        "menu-class": "menu"
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.searchPlaceholderText), 1)
        ]),
        content: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            (_ctx.pageWithSearch && _ctx.headerSearchSlice)
              ? (_openBlock(), _createBlock(_unref(SliceZone), {
                  key: 0,
                  slices: [_ctx.headerSearchSlice],
                  components: _unref(components)
                }, null, 8, ["slices", "components"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["class"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_ctx.pageWithSearch && _ctx.headerSearchSlice)
          ? (_openBlock(), _createBlock(_unref(SliceZone), {
              key: 0,
              slices: [_ctx.headerSearchSlice],
              components: _unref(components)
            }, null, 8, ["slices", "components"]))
          : _createCommentVNode("", true)
      ]))
}
}

})